<template>
	<div style="width:900px;">
		<div class="view_inner" style="overflow-y:scroll;height:700px;">
			<ul>
				<li v-if="!read_only">
					<textarea style="padding:2px;" rows="6" v-model.trim="new_memo_content" class="textarea_type" placeholder="Enter New Memo..."></textarea>
					<a href="javascript:;" class="gray_bt2 mgr_5" @click="saveNew()">Save New Memo</a>
				</li>
				<li v-for="(memo, index) in memos" v-bind:key="memo.partner_memo_no" style="padding-top:10px;">
					<textarea style="padding:2px;margin-top:4px;" rows="6" v-model.trim="memo.content" :disabled="memo.close_yn == 'Y'" :readonly="read_only" class="textarea_type"></textarea>
					<span v-if="memo.close_yn == 'Y' && user.memo_mgmt && !read_only">
						<a href="javascript:;" class="gray_bt2 mgr_5" @click="activateEach(memo)">Activate Memo</a>
						<a href="javascript:;" class="gray_bt2" @click="del(memo, index)">Delete</a>
					</span>
					<span v-else-if="user.memo_mgmt && !read_only">
						<a href="javascript:;" class="gray_bt2 mgr_5" @click="saveEach(memo)">Save Memo</a>
						<a href="javascript:;" class="gray_bt2" @click="closeEach(memo)">Close Memo</a>
					</span>
					<a v-if="user.memo_mgmt && !read_only" href="javascript:;" class="gray_bt2 mgr_10" style="margin-left:10px;" @click="setPinned(memo, !memo.pinned)">
						<!-- <img :src="require(`@/assets/img/theme2/background/aside_bt.png`)" /> -->
						<font color="blue">{{ memo.pinned ? 'Un-Pin' : 'Pin' }}</font>
					</a>
					<span style="display:inline-block;padding-top:4px;">
						Created {{ memo.crt_dt | moment('HH:mm:ss MM-DD-YYYY') }} by {{ memo.crt_user }}<template v-if="memo.upd_dt">, Last Updated {{ memo.upd_dt | moment('HH:mm:ss MM-DD-YYYY') }} by {{ memo.upd_user }}</template>
					</span>
				</li>
				<!-- <li style="padding:3px;">
					Created 18:23:23 02-24-2020 by gyjkim, Last Updated 19:23:23 02-24-2020 by admin
					<textarea style="padding:2px;" rows="3" name="customer_memo_content" class="textarea_type">test</textarea>
				</li>
				<li style="padding:3px;">
					<textarea style="padding:2px;" rows="3" name="customer_memo_content" class="textarea_type" readonly disabled="disabled"></textarea>
				</li>
				<li style="padding:3px;">
					<textarea style="padding:2px;" rows="3" name="customer_memo_content" class="textarea_type" readonly disabled="disabled"></textarea>
				</li>
				<li style="padding:3px;">
					<textarea style="padding:2px;" rows="3" name="customer_memo_content" class="textarea_type" readonly disabled="disabled"></textarea>
				</li> -->
			</ul>
		</div>
		<div class="view_bottom_bt" style="padding-top:15px;">
			<a v-if="!read_only" href="javascript:;" class="search_bt mgr_10" @click="print()">Print</a>
			<a v-if="user.memo_mgmt && !read_only" href="javascript:;" class="search_bt" @click="confirm()">Save and Close All</a>
			<a v-if="user.memo_mgmt && !read_only" href="javascript:;" class="search_bt mgr_15" style="margin-left:10px;" @click="save()">Save All Only</a>
			<a href="javascript:;" type="button" class="gray_bt" @click="close()">Cancel</a>
		</div>
	</div>
</template>

<script>
// import { inputSelectOnClick } from '@/utils/etc.js';
// import '@/assets/css/table_box.css';
import { apiSelectPartnerAndMemos, apiSelectMemoList, apiSubmitMemo, apiDeleteMemo, apiInsertEachMemo, apiUpdateEachMemo } from '@/api/partner/index.js';
import { apiGetReportTemplate, Report, reportMrtUrl } from '@/api/util';

export default {
	data: function() {
		return {
			memos: [],
			new_memo_content: null,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	props: {
		partner_code: String,
		// #3406 : State 제한 사용자의 SO 상세처럼 메모를 보기만 할 때. 입력·저장·출력을 숨긴다.
		read_only: Boolean,
		// customerOnly: Boolean,
		// vendorOnly: Boolean,
	},
	methods: {
		async saveNew() {
			var param = {
				partner_code: this.partner_code,
				new_memo_content: this.new_memo_content,
			};

			const { data } = await apiInsertEachMemo(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.new_memo_content = null;
				this.selectMemoList();
				//this.close();
				//this.$emit('close', true);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async updateEach(param) {
			const { data } = await apiUpdateEachMemo(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				// this.new_memo_content = null;
				this.selectMemoList();
				//this.close();
				//this.$emit('close', true);
				return true;
			} else {
				this.$toast.error(data.msg);
			}
		},
		async saveEach(m) {
			var param = {
				partner_memo_no: m.partner_memo_no,
				content: m.content,
				close_yn: m.close_yn,
				pinned: m.pinned,
			};
			await this.updateEach(param);
		},
		async closeEach(m) {
			var param = {
				partner_memo_no: m.partner_memo_no,
				content: m.content,
				close_yn: 'Y',
				pinned: m.pinned,
			};
			if (await this.updateEach(param)) m.close_yn = 'Y';
		},
		async activateEach(m) {
			var param = {
				partner_memo_no: m.partner_memo_no,
				content: m.content,
				close_yn: 'N',
				pinned: m.pinned,
			};
			if (await this.updateEach(param)) m.close_yn = 'N';
		},
		async setPinned(m, pinned) {
			var param = {
				partner_memo_no: m.partner_memo_no,
				content: m.content,
				close_yn: m.close_yn,
				pinned: pinned,
			};
			if (await this.updateEach(param)) m.pinned = pinned;
		},
		async print() {
			const { data } = await apiSelectPartnerAndMemos(this.partner_code);
			data.print_user = this.user.user_id;
			data.print_dt = this.$moment(new Date()).format('yyyy-MM-DD HH:mm:ss');

			const reportTemplate = await apiGetReportTemplate('PartnerMemo', reportMrtUrl('PartnerMemo'));
			const report = new Report(reportTemplate, data, 'PartnerMemo');
			this.$store.commit('setReport', report);
		},
		del(m, idx) {
			this.$alertify.confirm('Are you sure to delete this memo?', () => {
				this.delConfirm(m, idx);
			});
		},
		async delConfirm(m, idx) {
			//console.log(m);
			const { data } = await apiDeleteMemo(m);

			if (data.result) {
				this.$toast.success('Deleted successfully');
				this.memos.splice(idx, 1);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async save(close) {
			//console.log(this.new_memo_content);
			var param = {
				partner_code: this.partner_code,
			};
			if (this.new_memo_content) param.new_memo_content = this.new_memo_content;

			var updated_memos = this.memos.filter(m => m.close_yn == 'N');
			if (updated_memos.length > 0) param.memos = updated_memos;

			if (close) param.close_yn = 'Y';

			const { data } = await apiSubmitMemo(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.new_memo_content = null;
				//this.selectMemoList();
				//this.close();
				this.$emit('close', true);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async confirm() {
			await this.save(true);
		},

		async selectMemoList() {
			var param = {
				partner_code: this.partner_code,
				limit_count: 5, // Newjigu의 경우에는 다 가져옴
			};

			const { data } = await apiSelectMemoList(param);
			this.memos = data.memoList;
			this.$forceUpdate();
			//console.log(data);

			// // this.pensioners = data;
			// // if (this.pensioners.length > 0 && this.selectedPsNo == null) {
			// // 	this.selectRow(this.pensioners[0]);
			// // }
			// //console.log(data);
			// this.partners = data.partnerList;
			// if (this.partners.length == 0) {
			// 	this.$toast.warning('No partners found');
			// }
			// // this.users.forEach(function(user) {
			// // 	user.selected = false;
			// // });
		},

		// async selectRow(partner) {
		// 	const { data } = await apiSelectPartner({
		// 		code: partner.code,
		// 	});

		// 	//console.log(partner);
		// 	//this.$emit('set-partner', partner);
		// 	this.$emit('set-partner', data.partner);
		// 	this.close();
		// },

		async index() {},
		close() {
			this.$emit('close', false);
		},
		handleEscKey(event) {
			if (event.key === 'Escape') {
				this.close();
			}
		},
	},
	created() {
		//console.log(this.partner_code);
		this.index();
		this.selectMemoList();
		document.addEventListener('keyup', this.handleEscKey);
	},
	mounted() {},
	beforeDestroy() {
		document.removeEventListener('keyup', this.handleEscKey);
	},
};
</script>

<style></style>
